import { baseClasses } from '@weatherbug/common';
const { PulseBaseProvider } = baseClasses;

const _setUnitsUri = '/api/units';

function setUnitsValidationFunction(response) {
    return response?.result?.unitSystem && response?.result?.windUnit && response?.result?.pressureUnit
}

export class UnitsProvider extends PulseBaseProvider {
    constructor(authId, secret, options, logger) {
        super(authId, secret, options, logger);
    }

    async setUnits(unitSystem, tempUnit, windUnit, pressureUnit) {
        const queryParams = {
            unitval: unitSystem,
            tempUnitVal: tempUnit,
            windUnitVal: windUnit,
            pressureUnitVal: pressureUnit
        };

        return await super.putData(queryParams, null, _setUnitsUri, true, setUnitsValidationFunction, false);
    }
}
